import { MIXPANEL_TOKEN } from '../../config/config';
import { IS_LOCAL } from '../../config/FruitfulEnvironment';

export const isMixpanelEnabled = () => {
    return !IS_LOCAL && MIXPANEL_TOKEN != null;
};
